import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { ParticipantAuthProvider } from "@/context/ParticipantAuthContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import { ProtectedParticipantRoute, ProtectedAdminRoute } from "@/components/ProtectedRoute";

import LandingPage from "@/pages/LandingPage";
import ParticipantLogin from "@/pages/ParticipantLogin";
import AdminLogin from "@/pages/AdminLogin";
import ParticipantPortal from "@/pages/ParticipantPortal";
import DiagnosticPage from "@/pages/DiagnosticPage";
import ActivityPage from "@/pages/ActivityPage";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminParticipants from "@/pages/admin/AdminParticipants";
import AdminParticipantDetail from "@/pages/admin/AdminParticipantDetail";
import AdminDiagnosticSummary from "@/pages/admin/AdminDiagnosticSummary";
import AdminActivities from "@/pages/admin/AdminActivities";
import AdminReviews from "@/pages/admin/AdminReviews";
import AdminExports from "@/pages/admin/AdminExports";
import AdminGapReport from "@/pages/admin/AdminGapReport";
import AdminSettings from "@/pages/admin/AdminSettings";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ParticipantAuthProvider>
          <AdminAuthProvider>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<ParticipantLogin />} />
              <Route path="/admin/login" element={<AdminLogin />} />

              <Route path="/portal" element={<ProtectedParticipantRoute><ParticipantPortal /></ProtectedParticipantRoute>} />
              <Route path="/diagnostico" element={<ProtectedParticipantRoute><DiagnosticPage /></ProtectedParticipantRoute>} />
              <Route path="/actividades/:week" element={<ProtectedParticipantRoute><ActivityPage /></ProtectedParticipantRoute>} />

              <Route path="/admin" element={<ProtectedAdminRoute><AdminLayout /></ProtectedAdminRoute>}>
                <Route index element={<AdminOverview />} />
                <Route path="participantes" element={<AdminParticipants />} />
                <Route path="participantes/:id" element={<AdminParticipantDetail />} />
                <Route path="diagnostico" element={<AdminDiagnosticSummary />} />
                <Route path="actividades" element={<AdminActivities />} />
                <Route path="revisiones" element={<AdminReviews />} />
                <Route path="informe-brechas" element={<AdminGapReport />} />
                <Route path="exportaciones" element={<AdminExports />} />
                <Route path="ajustes" element={<AdminSettings />} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AdminAuthProvider>
        </ParticipantAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
